var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-message"},[_c('h1',[_vm._v("\n    "+_vm._s(_vm.header)+"\n  ")]),_c('p',[_vm._t("details",[_vm._v("\n      "+_vm._s(_vm.details || _vm.defaultDetails)+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }